module.exports = __webpack_public_path__ + "img/mr.f7f3f21e.svg";